import React, { Fragment } from "react";
import { observer, inject } from "mobx-react";
import { 
  ShareVideoModal, 
  DeleteVideoModal, 
  DownloadVideoModal, 
  AssignAssistantModal
} from '@myplay/ui';

import { SHARE, DELETE, DOWNLOAD, ASSIGN_ASSISTANT } from "../../utils/constants";

const VideoPreviewActions = ({ VideosStore, TeamsStore, displayedModal, closeModal, selectedVideoContainer, currentTeamMembers }) => {
  const { shareVideoContainer, deleteVideo, downloadVideo, assignAssistant } = VideosStore;
  const { teams } = TeamsStore;

  const handleApproveShareVideo = teamToShareWith => {
    shareVideoContainer(selectedVideoContainer._id, teamToShareWith);
    closeModal();
  };

  const handleApproveDelete = async ()=> {
    await deleteVideo(selectedVideoContainer._id);
    closeModal();
  };

  const handleApproveDownload = videoId => {
    downloadVideo(videoId, selectedVideoContainer._id);
    closeModal();
  };

  const handleApproveAssignAssitant = assistantId => {  
    assignAssistant(assistantId, selectedVideoContainer._id);
    closeModal();
  };

  return (
    <Fragment>
      {displayedModal === SHARE &&
        <ShareVideoModal
          isVisible={displayedModal === SHARE}
          onDecline={closeModal}
          onApprove={handleApproveShareVideo}
          teams={teams}
          recordTeamId={selectedVideoContainer.team._id}
          thumbnailUri={selectedVideoContainer.video.thumbnailUri}
        />
      }
      {displayedModal === DELETE &&
        <DeleteVideoModal
          isVisible={displayedModal === DELETE}
          onDecline={closeModal}
          onApprove={handleApproveDelete}
        />
      }
      {displayedModal === DOWNLOAD &&
        <DownloadVideoModal
          isVisible={displayedModal === DOWNLOAD}
          video={selectedVideoContainer.video}
          onDecline={closeModal}
          onApprove={handleApproveDownload}
        />
      }
      {displayedModal === ASSIGN_ASSISTANT &&
        <AssignAssistantModal
          isVisible={displayedModal === ASSIGN_ASSISTANT}
          members={currentTeamMembers}
          onClose={closeModal}
          onApprove={handleApproveAssignAssitant}
        />
      }
    </Fragment>
  );
};

export default inject("VideosStore", "TeamsStore")(observer(VideoPreviewActions));